module.exports = __webpack_public_path__ + "img/partner_bg.b209361e.png";